import React, { useContext, useEffect, useState } from 'react';

import CardsList from '../cardList';
import AssetDetailModal from '../../assetDetailModal';
import GetAssetAttributes from "../../../../functions/GetAssetAttributes";
import APIHelper from "../../../../hooks/useAPIHelper";

import AssetListContext from '../../../context/assetListContext';
import AppStateContext from "../../../context/appStateContext";

const JobDetailAssetCardList: React.FC<any> = props => {
  const { assetList, location } = props;

  const { selectedAsset, clearAssetDetails, updateAssetAttributes } = useContext(AssetListContext);
  const { token } = useContext(AppStateContext);

  const getAttributes = APIHelper();

  const [modalActive, setModalActive] = useState();

  const handleClick = () => {
    setModalActive(!modalActive);
  };

  useEffect(() => {
    return () => {
      clearAssetDetails();
    }
  },[]);


  useEffect(() => {
    if(modalActive != undefined && modalActive) {
      getAttributes.run(GetAssetAttributes, (data: []) => updateAssetAttributes(data), [token,selectedAsset.SerialNo]);
    }
  }, [modalActive]);

  return (
    <div>
      <CardsList itemList={assetList} page={location} type="asset" clickControl={handleClick}/>
      {modalActive && <AssetDetailModal data={selectedAsset} active={modalActive} handleModal={handleClick}/>}
    </div>
  );
};

export default JobDetailAssetCardList;
